import { preload, changePlayqueue } from './AudioPlayer/playerActions'
import albumController from '../../utils/controllers/AlbumController'
import { ORIGIN_PLAYQUEUE_TYPES } from '../../components/miniPlayer/AudioPlayer/playerConstants'


export const openTrack = (track) => (dispatch, getState) =>
	changePlayqueue([track], ORIGIN_PLAYQUEUE_TYPES.track, track.id)(dispatch, getState)

export const open = (element, type) => (dispatch, getState) => {
	switch (type) {
		case ORIGIN_PLAYQUEUE_TYPES.track:
			preload()
			return openTrack(element)(dispatch, getState)
		case ORIGIN_PLAYQUEUE_TYPES.album:
			preload()
			return albumController.playAlbum(element)
		default:
			console.log('type inconnu')
	}
}



// WEBPACK FOOTER //
// ./src/components/miniPlayer/miniPlayerActions.js